<template>
  <PageWrapper>
    <BlockedUsersList></BlockedUsersList>
  </PageWrapper>
</template>

<script>
export default {
  components: {
    PageWrapper,
    BlockedUsersList,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import BlockedUsersList from "@/views/components/Block/BlockedUsersList.vue";
</script>
